<template>
  <div>
    <a-tabs :active-key="activeKey" @change="changeTab">
      <a-tab-pane
        v-for="item in showHasPermissionTabs"
        :key="item.routeName"
        :tab="item.tabName"
      >
        <router-view v-if="activeKey===item.routeName" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import { hasPermission } from '@/utils/permission'
import { findProfileSupplierName } from '@/api/profile_supplier'

export default {
  name: 'ShowProfileSupplierTab',
  data() {
    return {
      activeKey: '',
      allTabs: [
        { routeName: 'profile_supplier_info', tabName: '基本信息', menu: 'profile_suppliers/show' },
        { routeName: 'profile_supplier_profiles', tabName: '已划拨Profile列表', menu: 'profile_supplier_profiles' }
      ],
      showHasPermissionTabs: []
    }
  },
  computed: {
    profileSupplierId() {
      return parseInt(this.$route.params.id)
    }
  },
  watch: {
    profileSupplierId() {
      this.setBreadcrumb()
    }
  },
  created() {
    this.activeKey = this.$route.name
    this.fetchShowHasPermissionTabs()
    this.setBreadcrumb()
  },
  methods: {
    setBreadcrumb() {
      findProfileSupplierName(this.profileSupplierId).then((res) => {
        if (res.code === 0) {
          this.$store.dispatch('SetDynamicBreadCrumbsPlaceholder', { ':profile_supplier_name': res.data.name })
        }
      })
    },

    isShowMenu(menu) {
      return hasPermission(menu)
    },

    fetchShowHasPermissionTabs() {
      let isIncludeActiveKey = false

      this.allTabs.forEach((value) => {
        if (this.isShowMenu(value.menu)) {
          this.showHasPermissionTabs.push(value)
          if (value.routeName === this.activeKey) {
            isIncludeActiveKey = true
          }
        }
      })

      if (!isIncludeActiveKey && this.showHasPermissionTabs.length > 0) {
        this.activeKey = this.showHasPermissionTabs[0].routeName
      }
    },

    changeTab(activeKey) {
      this.activeKey = activeKey
      this.$router.push({ name: activeKey })
    }
  }
}
</script>
